module.exports = __webpack_public_path__ + "img/mobile-th.9a82660f.jpg";